var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 322.5 339.3",
    style: {
      enableBackground: "new 0 0 322.5 339.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#136189;}\n\t.st1{fill:#136DA0;}\n\t.st2{fill:#258BBF;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{font-family:'ProximaNova-Medium';}\n\t.st5{font-size:15px;}\n\t.st6{fill:#3A93AD;}\n\t.st7{fill:#40ACCC;}\n\t.st8{fill:#59C0EA;}\n\t.st9{fill:#2790BA;}\n\t.st10{fill:#2C9BD1;}\n\t.st11{fill:#3EB2E1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32091",
    transform: "translate(-731.385 -215.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32087",
    transform: "translate(946.904 180.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13726",
    className: "st0",
    d: "M0,262l53.5,27.9l1.1-205L0,56.9V262z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13727",
    className: "st1",
    d: "M53.5,84.8v205l53.5-24.4v-205L53.5,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13728",
    className: "st2",
    d: "M54.3,34.6L0,56.9l53.5,101.3L107,60.4L54.3,34.6z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 31.428 73.456)",
    className: "st3 st4 st5"
  }, "Step 3")), /*#__PURE__*/React.createElement("g", {
    id: "Group_32088",
    transform: "translate(854.429 265.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13729",
    className: "st6",
    d: "M0,216.3l53.5,27.9L54.6,85L0,57.1V216.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13730",
    className: "st7",
    d: "M107,219.8l-53.5,24.4V85L107,60.6V219.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13731",
    className: "st8",
    d: "M53.5,158.4L0,57.1l54.3-22.3L107,60.6L53.5,158.4z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 32.423 77.484)",
    className: "st3 st4 st5"
  }, "Step 2")), /*#__PURE__*/React.createElement("g", {
    id: "Group_32089",
    transform: "translate(751 349.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32090",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13732",
    className: "st9",
    d: "M0,177l53.5,27.9l1.1-119.1L0,57.9V177z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13733",
    className: "st10",
    d: "M53.5,85.8v119.1l53.5-24.4V61.4L53.5,85.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13734",
    className: "st11",
    d: "M0,57.9l54.9,101.3L107,61.4L54.3,35.6L0,57.9z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 31.915 78.391)",
    className: "st3 st4 st5"
  }, "Step 1"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep0);
export default __webpack_public_path__ + "static/media/step0.2d6eae825ef6755f9dd746c4b16da312.svg";
export { ForwardRef as ReactComponent };